import React, { useContext } from 'react'
import Heading from '@react/react-spectrum/Heading'
import Link from '../Nav/Link'
import BackButton from '../Nav/BackButton'
import Title from '../Nav/Title'
import Switch from '../Nav/Switch'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import useMultilineText from '../hooks/useMultilineText'
import { EasybakeContext } from '../EasybakeProvider'

export default function NavPreset () {
    const { page } = useContext(EasybakeContext)
    const summary = useMultilineText(__('preset_nav_summary'))
    return (
        <div className="adobe-easybake-nav feature">
            <BackButton className="adobe-easybake-nav-back-button"/>
            <div className="adobe-easybake-nav-content">
                <Title title={__('preset_nav_title')} />
                <div className="summary">
                    {summary}
                </div>
                <Link className="adobe-easybake-nav-link" referrer={`documentation:${page}:nav`} label={__('link_doc')} url={__('url_doc_presets')} />
                <div className="adobe-easybake-nav-actions">
                    <Heading variant="subtitle2">
                        <Switch group="preset" label={__('preset_nav_apply_agedphoto')} action="agedphoto" position="labelLeft" />
                        <Switch group="preset" label={__('preset_nav_apply_crossprocess')} action="crossprocess" position="labelLeft" />
                        <Switch group="preset" label={__('preset_nav_apply_custompresets')} action="custompresets" position="labelLeft" />
                        <Switch group="preset" label={__('preset_nav_apply_matte')} action="matte" position="labelLeft" />
                        <Switch group="preset" label={__('preset_nav_apply_turquoisered')} action="turquoisered" position="labelLeft" />
                    </Heading>
                </div>
            </div>
        </div>
    )
}
